import React from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import TransactionListTable from "./AccountsList";
import messages from "components/messagesDescription";

const {
  NumDescription,
  transactionDescription,
  categoryDescription,
  transactedOnDescription,
  effectiveOnDescription,
  amountDescription,
} = messages;

const TransactionList = ({ intl, account, hideCurrency = false }) => {
  const rows = account.transactions.map((transaction, idx) => ({
    ...transaction,
    incrementalID: idx + 1,
  }));

  const columns = [
    {
      displayLabel: intl.formatMessage(NumDescription),
      fieldID: "incrementalID",
      shouldDisplay: true,
      isIntlSkipped: true,
    },
    {
      displayLabel: intl.formatMessage(transactionDescription),
      fieldID: "reference",
      shouldDisplay: true,
      format: "${'@transactionDesc(transactionType, reference)'}",
    },
    {
      displayLabel: intl.formatMessage(categoryDescription),
      fieldID: "transactionType",
      shouldDisplay: true,
    },
    {
      displayLabel: intl.formatMessage(transactedOnDescription),
      fieldID: "transactionDate",
      shouldDisplay: true,
      format: "${ '@date(transactionDate)'}",
    },
    {
      displayLabel: intl.formatMessage(effectiveOnDescription),
      fieldID: "effectiveDate",
      shouldDisplay: true,
      format: "${ '@date(effectiveDate)'}",
    },
    {
      displayLabel: intl.formatMessage(amountDescription),
      fieldID: "actualAmount",
      shouldDisplay: true,
      format: "${'@currency(actualAmount)'}",
    },
  ];

  return (
    <div style={{ marginTop: "20px", marginBottom: "20px" }}>
      {rows.length > 0 && (
        <TransactionListTable
          currency={account.currency}
          rows={rows}
          columns={columns}
          hideCurrency={hideCurrency}
        />
      )}
    </div>
  );
};

TransactionList.propTypes = {
  account: PropTypes.object,
  intl: intlShape.isRequired,
  hideCurrency: PropTypes.bool,
};

export default injectIntl(TransactionList);



// WEBPACK FOOTER //
// ./components/claim/TransactionList.js